import { Typography, List, ListItem, ListItemText, Box, Card, CardContent, Grid, Chip } from '@mui/material';
import SEO from 'features/shared/components/common/SEO';

export default function AsesoriaTI(){
  return (
    <>
      <SEO 
        title="Asesoría en TI | Rolsys Solutions"
        description="Consultoría estratégica para alinear la tecnología con tus objetivos de negocio. Cobertura nacional."
      />

      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
          <Typography variant="h3" sx={{ fontWeight:800 }}>
            Asesoría en TI
          </Typography>
          <Chip label="Cobertura Nacional" color="primary" />
        </Box>

        <Typography variant="h6" sx={{ mb: 4, color: 'text.secondary' }}>
          Consultoría estratégica para alinear la tecnología con tus objetivos de negocio
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Card elevation={0} sx={{ border: '1px solid #eee', mb: 3 }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  ¿Qué incluye nuestro servicio?
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText 
                      primary="Evaluación de infraestructura tecnológica"
                      secondary="Análisis completo de tu entorno tecnológico actual"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Roadmap tecnológico personalizado"
                      secondary="Plan estratégico alineado con tus objetivos de negocio"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Seguridad y continuidad operativa"
                      secondary="Estrategias para proteger y mantener tu operación"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemText 
                      primary="Optimización de costos tecnológicos"
                      secondary="Identificación de oportunidades de ahorro y eficiencia"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>

            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 2, fontWeight: 600 }}>
                  Beneficios para tu empresa
                </Typography>
                <List>
                  <ListItem>
                    <ListItemText primary="Decisiones tecnológicas informadas y estratégicas" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Reducción de riesgos operativos y de seguridad" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Optimización del retorno de inversión en tecnología" />
                  </ListItem>
                  <ListItem>
                    <ListItemText primary="Mejora en la competitividad y eficiencia operativa" />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={4}>
            <Card elevation={0} sx={{ border: '1px solid #eee' }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                  Modalidad de trabajo
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Cobertura:</strong> Nacional (remoto y presencial)
                </Typography>
                <Typography variant="body2" sx={{ mb: 2 }}>
                  <strong>Duración:</strong> Proyectos desde 2 semanas hasta 6 meses
                </Typography>
                <Typography variant="body2">
                  <strong>Entregables:</strong> Reportes ejecutivos, roadmaps y recomendaciones técnicas
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}